exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.img-gallery[data-v-5cf6a07f] {\n  width: auto;\n  height: 160px;\n  border-radius: 0.5rem;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n@media only screen and (max-width: 600px) {\n.img-gallery[data-v-5cf6a07f] {\n    height: 110px;\n}\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-5cf6a07f","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/serviceRequest/ServiceRequestDetailForPartner.vue
// module id = 2025
// module chunks = 0